var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconPathName)?_c('div',{staticClass:"NotificationsListItemIcon icon"},[(_vm.type)?_c('BaseImage',{attrs:{"force":"","src":require(("images/icon/png-emoji/" + _vm.iconPathName + ".png")),"alt":_vm.iconPathName}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }